import { render } from "./ChainCustomerForm.vue?vue&type=template&id=06e5a016&scoped=true"
import script from "./ChainCustomerForm.vue?vue&type=script&lang=js"
export * from "./ChainCustomerForm.vue?vue&type=script&lang=js"

import "./ChainCustomerForm.vue?vue&type=style&index=0&id=06e5a016&scoped=true&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e5a016"]])

export default __exports__